import Vue from 'vue'
import one from './one.vue'
// import router from './router' // 引入路由

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#one',
  render: h => h(one)
})


// WEBPACK FOOTER //
// ./src/one.js